import { BadgeCheck, ShieldCheck, Home, Map } from "lucide-react";
import { useBrand } from "../context/BrandContext";

export const TrustBar = () => {
  const b = useBrand();
  const items = [
    { icon: BadgeCheck, k: `USDOT ${b.usdot}`, v: b.mc, id: "authority" },
    { icon: ShieldCheck, k: "Licensed & Insured", v: "Fully insured carriers", id: "insured" },
    { icon: Home, k: "Door-to-Door", v: "Home, shop or business", id: "door" },
    { icon: Map, k: "Continental US", v: "All 48 contiguous states", id: "coverage" },
  ];
  return (
    <section className="bg-white border-y border-amber-500/20" data-testid="trust-bar">
      <div className="container-x grid grid-cols-2 lg:grid-cols-4">
        {items.map(({ icon: I, k, v, id }, i) => (
          <div key={id} className={`flex items-center gap-4 py-6 lg:py-7 ${i % 2 ? "pl-4 lg:pl-8" : "pr-4 lg:pl-8"} ${i ? "lg:border-l border-slate-200" : "lg:pl-0"}`} data-testid={`trust-item-${id}`}>
            <I className="w-7 h-7 text-orange-600 shrink-0" strokeWidth={1.5} />
            <div>
              <div className="font-display font-bold uppercase text-slate-900 tracking-wide text-base sm:text-lg leading-tight">{k}</div>
              <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-wider text-slate-600 mt-1">{v}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
